/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Icon, Text, Theme, useTheme } from 'bold-ui'

import { ConsultaSeguimentoArrowDown } from './ConsultaSeguimentoArrowDown'

export function ConsultaSeguimentoIndicatorStart() {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <div css={styles.root}>
      <HFlow alignItems='center' hSpacing={0.5} style={styles.box}>
        <Icon size={1} icon='playFilled' style={styles.icon} />
        <Text style={styles.label}>Comece por aqui</Text>
      </HFlow>
      <ConsultaSeguimentoArrowDown />
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  root: css`
    display: grid;
    justify-self: center;
    justify-items: center;
    color: ${theme.pallete.primary.main};
  `,
  box: css`
    height: 1.5rem;
    padding: 0 0.5rem;
    border-radius: 2rem;
    background: ${theme.pallete.surface.main};
    border: 1px solid ${theme.pallete.divider};
    color: ${theme.pallete.primary.main};
  `,
  icon: css`
    fill: ${theme.pallete.primary.c60};
  `,
  label: css`
    color: ${theme.pallete.primary.main};
    font-weight: bold;
  `,
})
